/**
 * Utilitários para manipulação de strings
 */

/**
 * Completa uma string com zero à esquerda até atingir o número especificado de caracteres
 * @param {string|number} valor - Valor a ser formatado
 * @param {number} tamanho - Tamanho final desejado (padrão: 8)
 * @returns {string} String formatada com zeros à esquerda
 * 
 * @example
 * completarComZeroEsquerda(123) // "00000123"
 * completarComZeroEsquerda("456", 6) // "000456"
 * completarComZeroEsquerda(12345678) // "12345678"
 * completarComZeroEsquerda(null) // "00000000"
 */
export const completarComZeroEsquerda = (valor, tamanho = 8) => {
  if (!valor) return '0'.repeat(tamanho);
  
  // Converter para string se não for
  const stringValor = String(valor);
  
  // Completar com zero à esquerda até atingir o tamanho especificado
  return stringValor.padStart(tamanho, '0');
};

/**
 * Completa uma string com zero à esquerda até 8 caracteres (função específica)
 * @param {string|number} valor - Valor a ser formatado
 * @returns {string} String formatada com 8 caracteres
 */
export const completarComZeroEsquerda8 = (valor) => {
  return completarComZeroEsquerda(valor, 8);
};

/**
 * Formata um número como string com zeros à esquerda
 * @param {number} numero - Número a ser formatado
 * @param {number} tamanho - Tamanho final desejado
 * @returns {string} String formatada
 */
export const formatarNumeroComZeros = (numero, tamanho) => {
  return completarComZeroEsquerda(numero, tamanho);
};

/**
 * Formata um código de cartório com zeros à esquerda
 * @param {string|number} codigo - Código do cartório
 * @returns {string} Código formatado com 8 dígitos
 */
export const formatarCodigoCartorio = (codigo) => {
  return completarComZeroEsquerda(codigo, 8);
};
